import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { staticPath } from '~/renderer/utils';

const WaitForRetail: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Flex
      p={6}
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      width="100%"
      height="100%"
      data-testid="cfd-getting-started"
    >
      <img
        width="200px"
        alt={t('hub.cfd.waitForRetail.openRetail')}
        src={`${staticPath}/assets/desktop-screen.png`}
      />
      <Text mt={6} size="large" color="gray-400" style={{ maxWidth: '580px' }}>
        {t('hub.cfd.waitForRetail.getStarted')}
      </Text>
      <Box as="ol" fontSize="large" color="gray-400">
        <li>{t('hub.cfd.waitForRetail.firstStep')}</li>
        <li>{t('hub.cfd.waitForRetail.secondStep')}</li>
        <li>{t('hub.cfd.waitForRetail.thirdStep')}</li>
        <li>{t('hub.cfd.waitForRetail.fourthStep')}</li>
      </Box>
    </Flex>
  );
};

export default WaitForRetail;
